module.exports = __webpack_public_path__ + "static/media/lock-phone.b548dc30.svg";